__turbopack_context__.v({
  "fallback": "Avatar-module__yRo9wq__fallback",
  "image": "Avatar-module__yRo9wq__image",
});
